import { Text, WarningIcon } from '@buffer-mono/popcorn'

import { selectGenerateContentLimits } from '~publish/legacy/ai/state/aiLimits/slice'
import { useAppSelector } from '~publish/legacy/store'

import type { JSX } from 'react'

/**
 *
 */
const Credits = (): JSX.Element | null => {
  const { generateContentTokensLeft, limitsLoaded } = useAppSelector((state) =>
    selectGenerateContentLimits(state),
  )

  return limitsLoaded && generateContentTokensLeft === 0 ? (
    <Text
      as="div"
      size="sm"
      color="warning"
      icon={<WarningIcon size="xsmall" />}
    >
      You&apos;ve used all your AI credits. Please reach out to support to get
      more.
    </Text>
  ) : null
}

export { Credits }
